import React from "react";
import { useState, useEffect } from "react";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Box, TextField } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useFormik } from "formik";
import axios from "helpers/API";
import * as Yup from "yup";
import ProgramacionDetalle from "./FeriadoDetalle";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import MsgGenericoAlerta from "componentes/MsgGenericoAlerta";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import { errorBackendMsg } from "helpers/helpers";
import TablaMaterialUI from "componentes/TablaMaterialUI";

const ageActual = () => Number(new Date().getFullYear());

function ModuloLista({ drawer, moduloEdit, recargarTabla, setRecargarTabla }) {
    const [rows, setRows] = useState([]);
    const [muestraDetalle, setMuestraDetalle] = useState(false);
    const [idProgramacion, setIdProgramacion] = useState(false);

    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);
    const [mensajeInfo, setMensajeInfo] = useState("");
    const [showInfo, setShowInfo] = useState(false);

    // Modals
    const [idBorrar, setIdBorrar] = useState(null);
    const [modalBorrar, setModalBorrar] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [msgError, setMsgError] = useState("");
    const [modalExito, setModalExito] = useState(false);
    const [msgExito, setMsgExito] = useState("");

    //---
    const [anio, setAnio] = useState(ageActual());

    const mostrarModalBorrar = (id) => {
        setIdBorrar(id);
        setModalBorrar(true);
    };

    useEffect(() => {
        getFeriados(anio);
    }, [anio]);

    React.useEffect(() => {
        if (recargarTabla) {
            getFeriados(anio);
            setRecargarTabla(false);
        }
    }, [recargarTabla]);

    const borrarABM = () => {
        const hook = () => {
            getFeriados(ageActual());
        };
        let peticion = {
            url: "/generales/feriados/eliminar",
            hook: hook,
            dataRequest: { id: idBorrar },
        };
        peticionBase(peticion);
    };

    const getFeriados = (anio) => {
        let peticion = {
            url: "/generales/feriados/listar",
            hook: setRows,
            dataRequest: { anio: anio },
        };
        peticionBase(peticion);
    };

    const validationSchema = Yup.object({
        anio: Yup.number()
            .typeError("Ingrese un número")
            .required("Ingrese un año")
            .integer("Debe ingresar un número entero")
            .min(ageActual(), `Ingrese un número mayor a ${ageActual() - 1}`)
            .max(2099, "Ingrese un número menor a 2100"),
    });

    const formik = useFormik({
        initialValues: {
            anio: ageActual(),
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setAnio(values.anio);
            setSubmitting(false);
        },
    });

    const peticionBase = ({
        url,
        dataRequest = {},
        hook = false,
        errorHook = false,
    }) => {
        axios
            .post(url, dataRequest)
            .then(function (response) {
                if (response.data.error) {
                    if (Boolean(errorHook)) {
                        errorHook(response.data);
                    } else {
                        setShowError(true);
                        setMensajeError(response.data.msg);
                    }
                } else {
                    if (Boolean(hook)) {
                        hook(response.data);
                    }
                }
            })
            .catch(function (error) {
                setMensajeError(errorBackendMsg(error));
            });
    };

    const editarABM = (row) => {
        const hook = (data) => {
            console.log("Como son los feriados", data);
            moduloEdit(data);
            drawer(true);
        };
        let peticion = {
            url: "/generales/feriados/obtener",
            hook: hook,
            dataRequest: { id: row.id },
        };
        peticionBase(peticion);
    };
    const parsearFechaADate = (fecha) => {
        const partes = fecha.split("/");
        const day = Number(partes[0]);
        const month = Number(partes[1]) - 1; // the month is 0-indexed
        const age = Number(partes[2]);
        return new Date(age, month, day);
    };

    /**
     * @param {String} name Nombre del atributo
     */
    const ordenarFechas = (param1, param2, name) => {
        let dato1 = param1.api.getCellValue(param1.id, name);
        let dato2 = param2.api.getCellValue(param2.id, name);
        return parsearFechaADate(dato1) - parsearFechaADate(dato2);
    };

    const columns = [
        { field: "id", headerName: "ID", width: 90, hide: true },
        {
            field: "descripcion",
            headerName: "Descripción",
            flex: 1,
            width: 150,
            editable: false,
        },
        {
            field: "fecha",
            headerName: "Fecha",
            valueGetter: (params) => params.row.fecha,
            sortComparator: (v1, v2, param1, param2) =>
                ordenarFechas(param1, param2, "fecha"),
            flex: 0.75,
            width: 150,
            editable: false,
        },
        {
            field: "fechaEjecucion",
            headerName: "Fecha Ejecución",
            valueGetter: (params) => params.row.fechaEjecucion,
            sortComparator: (v1, v2, param1, param2) =>
                ordenarFechas(param1, param2, "fechaEjecucion"),
            flex: 0.75,
            width: 150,
            editable: false,
        },
        {
            headerName: "Acciones",
            flex: 1,
            field: "acciones",
            renderCell: (data) => (
                <strong>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginLeft: 16 }}
                        onClick={() => editarABM(data.row)}
                    >
                        Editar
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        style={{
                            marginLeft: 16,
                            backgroundColor: "#CA0B00 ",
                            color: "white",
                        }}
                        onClick={() => mostrarModalBorrar(data.row.id)}
                    >
                        Borrar
                    </Button>
                </strong>
            ),
        },
    ];

    return (
        <>
            <ProgramacionDetalle
                show={muestraDetalle}
                id={idProgramacion}
                handleShow={(flag) => setMuestraDetalle(flag)}
            />

            <Grid item md={12}>
                {modalBorrar && (
                    <MsgConfirmacion
                        setVisible={setModalBorrar}
                        titulo="Borrar Feriado"
                        msg={"¿Desea borrar el Feriado seleccionado?"}
                        aceptar={borrarABM}
                    />
                )}
                {modalError && (
                    <MsgGenericoAlerta
                        setVisible={setModalError}
                        titulo="Error"
                        msg={msgError}
                    />
                )}
                {modalExito && (
                    <MsgGenericoAlerta
                        setVisible={setModalExito}
                        titulo="Info"
                        msg={msgExito}
                    />
                )}
                <APIMensajeMUI
                    mb={30}
                    tipo="error"
                    showMensaje={showError}
                    msg={mensajeError}
                />
                <APIMensajeMUI
                    mb={30}
                    tipo="info"
                    showMensaje={showInfo}
                    msg={mensajeInfo}
                />
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="filtros"
                        id="filtros"
                    >
                        <Typography variant="h5">
                            <strong>Filtros</strong>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Box>
                                    <TextField
                                        variant="outlined"
                                        label="Año"
                                        type="text"
                                        id="anio"
                                        name="anio"
                                        value={formik.values.anio}
                                        onChange={formik.handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        error={
                                            formik.touched.anio &&
                                            Boolean(formik.errors.anio)
                                        }
                                        helperText={
                                            formik.touched.anio &&
                                            formik.errors.anio
                                        }
                                    />
                                </Box>
                                <Box mt={2}>
                                    <Button
                                        onClick={formik.handleSubmit}
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Buscar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
            <Grid item md={12}>
                <Card>
                    <div style={{ height: 400, width: "100%" }}>
                        <TablaMaterialUI
                            columnas={columns}
                            filas={rows}
                            cargando={false}
                            sortModel={{
                                field: "fecha",
                                sort: "asc",
                            }}
                        />
                    </div>
                </Card>
            </Grid>
        </>
    );
}
export default ModuloLista;
